module.exports = __webpack_public_path__ + "media/Erklärvideo.6fdb7856.mp3";